import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { supabase } from "../services/supabase";
import RideForm from "../components/rides/RideForm";

const EditRidePage = () => {
  const { id } = useParams();
  const [ride, setRide] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadRide = async () => {
      const { data, error } = await supabase
        .from("rides")
        .select(`
          *,
          clients:profiles!client_id(full_name, phone, email)
        `)
        .eq("id", id)
        .single();

      if (error) {
        console.error(error);
        alert("Impossible de charger la course.");
      } else {
        setRide(data);
      }

      setLoading(false);
    };

    loadRide();
  }, [id]);

  if (loading) return <p>Chargement…</p>;
  if (!ride) return <p>Course introuvable.</p>;

  return (
    <RideForm
      mode="edit"
      rideId={id}
      initialData={ride}
    />
  );
};

export default EditRidePage;
